/**
 * Labstep
 *
 * @module screens/Authentication/ForgotPassword
 * @desc ForgotPasswordScreen
 */

import { UserFormForgotPassword as ForgotPasswordForm } from 'labstep-web/components/User/Form/ForgotPassword';
import { UserForgotPasswordContainer } from 'labstep-web/containers/User/ForgotPassword';
import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { Columns } from 'labstep-web/screens/Authentication/Columns';
import {
  AlreadyHaveAnAccount,
  SharedBody,
  SharedFooter,
  SignupLinks,
} from 'labstep-web/screens/Authentication/Shared';
import type React from 'react';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { IForgotPasswordProps } from './types';

export const ForgotPasswordComponent: React.FC<
  IForgotPasswordProps
> = ({ forgotPassword, status }) => {
  const hasResetAlready =
    status && status.error === null && status.isFetching === false;

  if (hasResetAlready) {
    return (
      <p>
        <b>Check your inbox for an email to reset your password.</b>
      </p>
    );
  }

  return (
    <div>
      <SharedBody>
        <ForgotPasswordForm
          forgotPassword={forgotPassword}
          status={status}
        />
      </SharedBody>

      <SharedFooter>
        <SignupLinks />
        <AlreadyHaveAnAccount />
      </SharedFooter>
    </div>
  );
};

export const ForgotPasswordColumns: React.FC<IForgotPasswordProps> = (
  props,
) => (
  <>
    <DocumentHead title="Forgot Password" />
    <Columns
      left={
        <div className={styles.imageContainer}>
          <Image src="/img/error/locked.svg" fluid />
        </div>
      }
      right={<ForgotPasswordComponent {...props} />}
      header="Reset password"
      explainer="Enter your email address and we will send you a link to reset your password"
    />
  </>
);

export const ForgotPassword: React.FC = () => (
  <UserForgotPasswordContainer>
    {(containerProps: IForgotPasswordProps) => (
      <ForgotPasswordColumns {...containerProps} />
    )}
  </UserForgotPasswordContainer>
);
